import { createInitialTargetSegmentItem } from "@shared/common/target-segment";
import type { PartialExceptKeys } from "@shared/common/types/common";
import type {
  IEngageableCampaign,
  ITargetSegmentItem,
} from "@shared/common/types/target-segment";

export const createSegmentManager = () => {
  const baseUrl = ANALYTICS_API_URL;

  const getEngageableCampaigns = async (
    userId: string | null
  ): Promise<IEngageableCampaign[]> => {
    if (!userId) {
      return [];
    }

    try {
      const res = await fetch(
        `${baseUrl}/api/v1/target-segment/engageable/user/${userId}?_v=${SDK_VERSION}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      ).then((res) => res.json());
      return res.data as IEngageableCampaign[];
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return [];
    }
  };

  const updateTargetSegment = async (
    props: PartialExceptKeys<
      ITargetSegmentItem,
      "campaignId" | "userId" | "engageable"
    >
  ) => {
    try {
      const res = await fetch(`${baseUrl}/api/v1/target-segment?_v=${SDK_VERSION}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: [
            createInitialTargetSegmentItem({ ...props, createdBy: "SDK" }),
          ],
        }),
      });
      return res.status === 200;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      return false;
    }
  };

  return {
    getEngageableCampaigns,
    updateTargetSegment,
  };
};
